import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { isMobileMode } from '@app/utils/utils';
import { closeError } from '@app/actions/popupsActions';

import Popup from '../Popup';
import './ErrorPopup.scss';

const ErrorPopup = ({ closeError, error: { intlValues, active, titleLocKey, locKey, message, ...props }, mobileView }) =>
  active && (
    <Popup className={classnames('error-popup', { mobile: mobileView })} titleLocKey={titleLocKey} closePopup={closeError} {...props}>
      {locKey ? <LocalizedText id={locKey} values={intlValues} tagName="div" /> : message || 'Oops! Something went wrong.'}
    </Popup>
  );

ErrorPopup.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  message: PropTypes.string,
  locKey: PropTypes.string,
  intlValues: PropTypes.object,
  titleLocKey: PropTypes.string,
  error: PropTypes.object,
  mobileView: PropTypes.bool,
  closeError: PropTypes.func.isRequired,
};

export default connect(({ popups: { error }, matrix: { ctx } }) => ({ error, mobileView: isMobileMode(ctx) }), { closeError })(
  ErrorPopup,
);
